import React from 'react';
import { ShimmeredDetailsList, SelectionMode, DetailsListLayoutMode, DetailsRow, Selection } from '@fluentui/react';
import { Color } from '../../const/Const';
import GridFooter from '../GridFooter/GridFooter';
import Number from '../Number/Number';
import _ from 'lodash';

const GridDefaultShimmerCheck = (props) => {

    let columns = [];
    if (props?.columns?.length > 0) {
        columns = props.columns.map((r, index) => {
            let vRow = { ...r };
            vRow.isResizable = true;
            vRow.key = r.fieldName;
            vRow.index = index;

            let classNames = [];
            if (r.isBold) {
                classNames.push("row-bold");
            }
            if (r.isCapitalize) {
                classNames.push("row-capitalize")
            }

            if (classNames?.length > 0) {
                vRow.className = classNames.join(" ");
            }

            if (r.colSize) {
                if (r.colSize == 'small') {
                    vRow.maxWidth = 100;
                }
                if (r.colSize == 'mid') {
                    vRow.maxWidth = 160;
                }
            }
            if (r.minColSize) {
                if (r.minColSize == 'mid') {
                    vRow.minWidth = 220;
                    vRow.maxWidth = 260;
                } else if (r.minColSize == 'large') {
                    vRow.minWidth = 320;
                    vRow.maxWidth = 360;
                }
            }

            if (r.number) {
                vRow.onRender = (pitem, pindex, pcolumn) => {
                    let tValue = 0;
                    if (pcolumn.key && pitem[pcolumn.key]) {
                        tValue = parseFloat(pitem[pcolumn.key]?.toString()?.replaceAll(",", ''));
                    }
                    return (
                        <Number value={tValue?.toFixed(2)} />
                    );
                };
            }

            return vRow;
        });
    }

    const onRenderDetailsFooter = (detailsFooterProps) => {

        let tColumns = [];

        if (detailsFooterProps?.columns?.length > 0) {
            tColumns = detailsFooterProps?.columns?.map((r, index) => {
                let tRow = { ...r };
                tRow = _.omit(tRow, "onRender");
                return tRow;
            });
        }

        if (tColumns?.length > 0) {
            return (
                <DetailsRow
                    {...detailsFooterProps}
                    columns={tColumns}
                    item={{}}
                    onRenderItemColumn={(item, index, column) => {
                        if (column) {
                            if (column.index == 0) {
                                return (
                                    <GridFooter>
                                        SUMMARY
                                    </GridFooter>
                                );
                            } else {
                                if (column.summary && props.data?.length > 0) {
                                    let tData = [...props.data];
                                    let tSummary = tData.map(r => {
                                        if (column.key && r[column.key] && !isNaN(parseFloat(r[column.key]?.toString()?.replaceAll(',', '')))) {
                                            return parseFloat(r[column.key]?.toString()?.replaceAll(',', ''));
                                        } else {
                                            return 0;
                                        }
                                    }).reduce((a, b) => a + b, 0);

                                    return (
                                        <GridFooter>
                                            <Number value={tSummary?.toFixed(2)} />
                                        </GridFooter>
                                    );

                                } else {
                                    return (
                                        <GridFooter>
                                        </GridFooter>
                                    );
                                }
                            }
                        }
                        return undefined;
                    }}
                />
            );
        } else {
            return null;
        }
    }

    const onSelect = new Selection({
        onSelectionChanged: () => {
            let tSelection = onSelect.getSelection();
            if (props.onSelect) {
                if (tSelection?.length > 0) {
                    props.onSelect(tSelection);
                } else {
                    props.onSelect([]);
                }
            }
        },
    });


    return (
        <div>
            <ShimmeredDetailsList
                styles={{
                    root: {
                        selectors: {
                            '.ms-DetailsHeader': {
                                paddingTop: '0px'
                            },
                            '.ms-DetailsRow-cell': {
                                color: '#201F1E'
                            }
                        }
                    }
                }}
                setKey={props.setKey ? props.setKey : null}
                selectionMode={SelectionMode.multiple}
                layoutMode={props.fixedColumns ? DetailsListLayoutMode.fixedColumns : DetailsListLayoutMode.justified}
                enableShimmer={props.loading ? true : false}
                compact={true}
                items={props.data ? props.data : []}
                columns={columns}
                onRenderRow={props.onRenderRow ? props.onRenderRow : null}
                onRenderDetailsFooter={props.summary && props.data?.length > 0 ? onRenderDetailsFooter : null}
                selection={onSelect}
            />
            {!props.loading && props?.data?.length <= 0 ? (
                <div style={{ backgroundColor: Color.white, textAlign: 'center', color: Color.grayNoData, paddingBottom: 18 }}>
                    {props.lang == "en" ? "No Data" : "Харуулах мэдээлэлгүй байна"}
                </div>
            ) : (
                null
            )}
        </div>
    );
}

export default GridDefaultShimmerCheck;